import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-change-draft-shipment-name-popup',
  templateUrl: './change-draft-shipment-name-popup.component.html',
  styleUrls: ['./change-draft-shipment-name-popup.component.scss']
})
export class ChangeDraftShipmentNamePopupComponent implements OnInit,OnDestroy {
  shipmentName: FormControl = new FormControl("");
  actions: any[];
  draftName: string;
  private destroy$ = new Subject<void>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ChangeDraftShipmentNamePopupComponent>,
    private datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.actions = [
      { text: "Cancel", buttonStyle: "underline" },
      { text: "Create"},
    ];
    if(this.data?.isAddToDraftShipment){
      this.actions.splice(0,0,{text: "Add To Existing Draft"})
    }
    let date = new Date();
    let currentDate
     if(this.data.isWalmart){
      currentDate = this.datepipe.transform(date, 'MM-dd-yy hh:mm:ss a');
      this.draftName = "WFS-(" + currentDate + ")";
     }else{
      currentDate = this.datepipe.transform(date, 'MM/dd/yy hh:mm:ss a');
      this.draftName = "FBA-(" + currentDate + ")";
     }
    this.shipmentName.setValue(this.draftName);
  }

  action(event) {
    if (
      this.data.confirmationButton &&
      this.data.confirmationButton === event &&
      this.data.callBackFn
    ) {
      this.data?.isAddToDraftShipment ? this.actions[2].spin = true : this.actions[1].spin = true;
      this.data.callBackFn(this.dialogRef, this.actions,this.shipmentName?.value);
    } else if(event == 'Add To Existing Draft') {
      this.dialogRef.close('AddToShipment');
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(false);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
